import React from "react";

const AIPoweredSelfServiceAutomation = () => {
  return (
    <div className="modal-content-body">
      <div className="modal-section">
        <div className="flex-content">
          <div>
            <h3>Use Case</h3>
          </div>
          <div>
            <p>
              Deploy a branded, GenAI-powered digital concierge to automate
              customer support and user journeys - across web, app, and contact
              centre touchpoints - streamlining service and boosting engagement
            </p>
          </div>
        </div>

        <div className="flex-content">
          <div>
            <h3>Solution</h3>
          </div>
          <div>
            <a
              href="https://aws.amazon.com/marketplace/pp/prodview-fe3jofu5kegzq?sr=0-5&ref_=beagle&applicationId=AWSMPContessa"
              target="_blank"
              rel="noopener noreferrer">
              Digital AI Concierge
            </a>{" "}
            (AWS Bedrock, Amazon Lex, custom GenAI, workflow automation)
          </div>
        </div>

        <div className="flex-content">
          <div>
            <h3>Target Segment</h3>
          </div>
          <div>
            <ul>
              <li>
                SMB/Enterprise companies with high-volume online, mobile, or app
                engagement
              </li>
              <li>
                Contact centre teams seeking to shift from human to digital
                first
              </li>
              <li>
                Brands prioritising automation, scalable self-service, and AI
                innovation
              </li>
            </ul>
          </div>
        </div>

        <div className="flex-content">
          <div>
            <h3>Target Personas</h3>
          </div>
          <div>
            <p>
              Head of Digital, Chief Customer Officer, CX Lead, Product Owner,
              Head of Automation
            </p>
          </div>
        </div>
      </div>

      {/* Opportunity & Qualification */}
      <div className="modal-section">
        <h2 className="modal-section-title">Opportunity and Qualification</h2>
        <div className="modal-section-grid">
          <div className="modal-column">
            <h3 className="modal-subtitle">
              What is the customer trying to accomplish?
            </h3>
            <ul>
              <li>Automate repetitive support and FAQs</li>
              <li>
                Provide 24/7 digital assistance with contextual,
                brand-consistent AI
              </li>
              <li>Lower contact centre workload and cost</li>
              <li>
                Enable seamless self-service across multiple digital channels
              </li>
              <li>
                Unlock advanced analytics and insight from customer journeys
              </li>
            </ul>
          </div>

          <div className="modal-column">
            <h3 className="modal-subtitle">Key Words/ Questions</h3>
            <ul>
              <li>Lacking new feature adoption or stuck on legacy workflows</li>
              <li>Want to improve/support AI, reporting, or automation</li>
              <li>
                Unsure if the platform is optimised for cost, compliance, or CX
              </li>
              <li>Seeking managed or advisory support for contact centre</li>
            </ul>
          </div>

          <div className="modal-column">
            <h3 className="modal-subtitle">Pain Point/ Challenge</h3>
            <ul>
              <li>
                Want 24/7 customer help or chat without increasing headcount
              </li>
              <li>Need a chatbot or AI persona that “fits our brand”</li>
              <li>Current chat automation is too basic or disconnected</li>
              <li>Struggling to answer repetitive questions quickly</li>
              <li>Interested in trying GenAI or AWS Bedrock for CX</li>
              <li>Want to connect AI to CRM/workflows</li>
            </ul>
          </div>

          <div className="modal-column">
            <h3 className="modal-subtitle">Qualifying Questions</h3>
            <ul>
              <li>
                Are you fully leveraging the latest AWS Connect features and AI
                capabilities?
              </li>
              <li>
                Would you value regular health checks, innovation reviews, and
                cost optimisation?
              </li>
              <li>Has performance plateaued since your initial launch?</li>
              <li>
                Would ongoing advisory and managed support free your team for
                higher-value work?
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Proposed Solution */}
      <div className="modal-section">
        <h2 className="modal-section-title">Proposed Solution / Value</h2>
        <div className="flex-content-half">
          <div>
            <h3>Solution Description</h3>
            <ul style={{marginTop: "10px"}}>
              <li>
                Bespoke AI persona design - trained on your brand voice,
                knowledge, and workflows
              </li>
              <li>
                End-to-end deployment - including discovery, process
                documentation, integrations, happy-path design, and safety
                guardrails
              </li>
              <li>
                Live monitoring & analytics - with continuous performance tuning
              </li>
              <li>
                Seamless escalation - smooth handoff to human agents when needed
              </li>
            </ul>
          </div>
          <div>
            <h3>Solution Benefits to AWS Customers</h3>
            <ul style={{marginTop: "10px"}}>
              <li>30% reduction in contact centre workload</li>
              <li>
                Always-on digital engagement with consistent brand experience
              </li>
              <li>
                Actionable journey analytics driving continuous improvement
              </li>
              <li>Lower TCO while enhancing overall service quality</li>
            </ul>
          </div>
        </div>

        {/* hello */}
        <h2 className="modal-section-title" style={{marginTop: "30px"}}>
          Objection Handling
        </h2>
        <div className="flex-content-half">
          <div>
            <p>
              Bots are too impersonal: Customised persona matches your brand
              voice, so customers feel heard.
            </p>

            <p>
              AI can't handle our unique processes: Fully trained on your
              workflows, with seamless human escalation when needed.
            </p>
            <p>
              Security & data risks: Built on robust, AWS-native, privacy-first
              automation with full guardrails.
            </p>
            <p>
              Too complex: iCXeed manages strategy, integrations, training, and
              support end-to-end.
            </p>
            <p>
              Our volumes may be too low:Scalable from pilot to enterprise with
              fast ROI.
            </p>
          </div>
        </div>
      </div>

      {/* FootNote */}
      <div className="modal-section" style={{border: 0}}>
        <div className="flex-content-half">
          <div className="flex-content-half">
            <div>
              <p>Resource Links</p>
            </div>
            <div>
              <p>Insert Link</p>
            </div>
          </div>
          <div className="flex-content-half">
            <div>
              <p>Average Opportunity ARR:</p>
            </div>
            <div>
              <p>
                Insert the expected Annualized AWS Consumption Revenue Value
              </p>
            </div>
          </div>
        </div>
        <div className="flex-content-half">
          <div className="flex-content-half">
            <div>
              <p>Case Study Links</p>
            </div>
            <div>
              <p>Insert Link</p>
            </div>
          </div>
          <div className="flex-content-half">
            <div>
              <p>Primary Partner Contact:</p>
            </div>
            <div>
              <p>
                Ryan Rayner, Co-Founder | ryan.rayner@icxeed.ai +61 438 286 198
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AIPoweredSelfServiceAutomation;
